import { render, staticRenderFns } from "./Bkbs.vue?vue&type=template&id=100ed47c"
import script from "./Bkbs.vue?vue&type=script&lang=js"
export * from "./Bkbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports